import cookie from 'js-cookie'

export function hideElement($element) {
	$element.style.display = 'none';
}

export function showElement($element, $display) {
	$element.style.display = $display == null ? 'block' : $display;
}

export function getParent($element) {
	return $element.parentNode;
}

export function getClosest(el, selector) {
	var matchesFn;

	// find vendor prefix
	['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
		if (typeof document.body[fn] == 'function') {
			matchesFn = fn;
			return true;
		}
		return false;
	})

	var parent;

	// traverse parents
	while (el) {
		parent = el.parentElement;
		if (parent && parent[matchesFn](selector)) {
			return parent;
		}
		el = parent;
	}

	return null;
}

export function fadeOut(el) {
	el.style.opacity = 1;

	(function fade() {
		if ((el.style.opacity -= .1) < 0) {
			el.style.display = "none";
		} else {
			requestAnimationFrame(fade);
		}
	})();
};

export function fadeIn(el, display) {
	el.style.opacity = 0;
	el.style.display = display || "block";

	(function fade() {
		var val = parseFloat(el.style.opacity);
		if (!((val += .1) > 1)) {
			el.style.opacity = val;
			requestAnimationFrame(fade);
		}
	})();
};


export function removeClassById($elementId, $className) {
	const $element = document.getElementById($elementId);
	if ($element.classList.contains($className)) {
		$element.classList.remove($className);
	}
}

export function addClassById($elementId, $className) {
	const $element = document.getElementById($elementId);
	if (!$element.classList.contains($className)) {
		$element.classList.add($className);
	}
}

export function addClass($element, $className) {
	if (!$element.classList.contains($className)) {
		$element.classList.add($className);
	}
}

export function removeClass($element, $className) {
	if ($element.classList.contains($className)) {
		$element.classList.remove($className);
	}
}

export function hasClass($element, $className) {
	return $element.classList.contains($className);
}

export function changeHtml($element, $html) {
	$element.innerHTML = $html;
}

export function serializeForm($form) {
	const form = $form;
	// Setup our serialized data
	let serialized = [];


	// Loop through each field in the form
	for (var i = 0; i < form.elements.length; i++) {

		var field = form.elements[i];

		// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
		if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

		// not push empty string
		if (field.value == '') continue;

		// If a multi-select, get all selections
		if (field.type === 'select-multiple') {
			for (var n = 0; n < field.options.length; n++) {
				if (!field.options[n].selected) continue;
				serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
			}
		}

		// Convert field data to a query string
		else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
			serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
		}
	}

	return serialized.join('&');
};

export function checkIfNull($data) {
	return ($data == undefined || $data == null);
}

export function getInternetExplorerVersion() {
	let rv = -1;
	if (navigator.appName == 'Microsoft Internet Explorer') {
		let ua = navigator.userAgent;
		let re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
		if (re.exec(ua) != null)
			rv = parseFloat(RegExp.$1);
	} else if (navigator.appName == 'Netscape') {
		let ua = navigator.userAgent;
		let re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
		if (re.exec(ua) != null)
			rv = parseFloat(RegExp.$1);
	}
	return rv;
}


export function redirect(url) {
	url = decodeURIComponent(url);
	if (url.indexOf("#") != -1) {
		window.location.href = url;
		window.location.reload();
	} else {
		if (!url) {
			window.location.reload();
		} else {
			window.location.replace(url);
		}
	}
}

export function setCookie(name, value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toGMTString();
	} else var expires = "";
	document.cookie = name + "=" + value + expires + "; path=/";
}


export function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function highlightText(text, highlightText) {
	// escape regex syntax
	highlightText = highlightText.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

	const regex = new RegExp(`${highlightText}`, 'gi');
	return text.replace(regex, match => {
		return `<strong>${match}</strong>`
	})
}

export function isIE() {

	const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';

	if (userAgent) {
		const msie = userAgent.indexOf("MSIE ");
		// If Internet Explorer
		const isIE = msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);

		return isIE
	}
	return false;
}

export function getCurrentTimestamp() {
	return Math.floor(Date.now() / 1000)
}

export function getDetectLocationId() {
	return cookie.get('VNWSearchJob[city]')
}
